// extracted by mini-css-extract-plugin
export default {"removeButton":"RemoveField_removeButton__5lCkM"};